import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const links = [
  { label: "Mission", href: "#about" },
  { label: "Numbers", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Industries", href: "#industries" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const goto = (href) => {
    setMenuOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <nav className="fixed top-5 left-0 right-0 z-50 px-6">
        <div className="max-w-3xl mx-auto nav-pill rounded-full flex items-center justify-between pl-5 pr-1.5 py-1.5">
          <a href="#" className="flex items-center gap-2 shrink-0">
            <span className="text-ink font-bold text-sm tracking-tight">
              TekJovi<span className="text-lime-600">®</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-6">
            {links.map((l) => (
              <button key={l.label} onClick={() => goto(l.href)}
                className="text-xs font-medium text-ink-500 hover:text-ink transition-colors duration-200">
                {l.label}
              </button>
            ))}
          </div>

          <button onClick={() => goto("#contact")}
            className="hidden md:inline-flex items-center gap-1.5 btn-dark text-xs font-semibold px-4 py-2 rounded-full">
            Pitch
            <ArrowRight size={12} />
          </button>

          <button onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu"
            className="md:hidden w-8 h-8 flex items-center justify-center rounded-full text-ink">
            {menuOpen ? <X size={17} /> : <Menu size={17} />}
          </button>
        </div>
      </nav>

      {/* Mobile slide-over */}
      <div className={`fixed inset-0 z-40 md:hidden transition-all duration-300 ${menuOpen ? "visible" : "invisible"}`}>
        <div onClick={() => setMenuOpen(false)}
          className={`absolute inset-0 bg-ink/40 backdrop-blur-sm transition-opacity duration-300 ${menuOpen ? "opacity-100" : "opacity-0"}`} />

        <div className={`absolute top-0 right-0 h-full w-72 bg-paper border-l hairline flex flex-col transition-transform duration-300 ease-in-out ${menuOpen ? "translate-x-0" : "translate-x-full"}`}>
          <div className="flex items-center justify-between px-6 py-5 border-b hairline">
            <span className="text-ink font-semibold text-sm">Menu</span>
            <button onClick={() => setMenuOpen(false)}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-ink/5 text-ink/60 hover:text-ink transition-colors">
              <X size={15} />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto slide-over-scroll px-5 py-5">
            <nav className="flex flex-col gap-1">
              {links.map((l) => (
                <button key={l.label} onClick={() => goto(l.href)}
                  className="text-left text-ink-500 hover:text-ink hover:bg-ink/4 px-3 py-3 rounded-lg text-sm font-medium transition-all duration-200">
                  {l.label}
                </button>
              ))}
            </nav>
            <div className="mt-8 pt-6 border-t hairline">
              <button onClick={() => goto("#contact")}
                className="btn-dark w-full text-sm font-semibold px-4 py-3 rounded-full flex items-center justify-center gap-2">
                Pitch your idea
                <ArrowRight size={14} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
